import axios from '@/axios.js'
import VueCookie from 'vue-cookie'
import config from '../../public/config'
const resourceHost = config.BASE_API_URL

class HttpRequest {
  static isErrorAlert = false;

  static sendRequest (type, url, param) {

    switch (type) {
    case 'get': return this.get(url, param)
    case 'put': return this.put(url, param)
    case 'post': return this.post(url, param)
    case 'delete': return this.delete(url, param)
      // case 'patch': return this.patch(url, param);
    default : {
      // eslint-disable-next-line no-unused-vars
      return new Promise(resolve => false)
    }

    }
  }

  static get (url, param) {
    this.verifyAccessToken()
    url = `${resourceHost}${  url}`
    return new Promise((resolve, reject) => {
      axios.get(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response)
          resolve(response)
        })
        .catch(err => {
          this.tooManyRequest(err)
          reject(err)
        })
    })
  }

  static put (url, param) {
    this.verifyAccessToken()
    url = `${resourceHost}${  url}`
    return new Promise((resolve, reject) => {
      axios.put(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response)
          resolve(response)
        })
        .catch(err => {
          this.tooManyRequest(err)
          reject(err)
        })
    })
  }

  static none_token_put (url, param) {
    url = `${resourceHost}${  url}`
    return new Promise((resolve, reject) => {
      axios.put(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response)
          resolve(response)
        })
        .catch(err => {
          this.tooManyRequest(err)
          reject(err)
        })
    })
  }

  static post (url, param) {
    this.verifyAccessToken()
    url = `${resourceHost}${  url}`
    return new Promise((resolve, reject) => {
      axios.post(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response)
          resolve(response)
        })
        .catch(err => {
          this.tooManyRequest(err)
          reject(err)
        })
    })
  }

  static none_token_post (url, param) {
    url = `${resourceHost}${  url}`
    return new Promise((resolve, reject) => {
      axios.post(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response)
          resolve(response)
        })
        .catch(err => {
          this.tooManyRequest(err)
          reject(err)
        })
    })
  }

  static delete (url, param) {
    this.verifyAccessToken()
    url = `${resourceHost}${  url}`
    return new Promise((resolve, reject) => {
      axios.delete(url, param)
        .then((response) => {
          response = this.combineKeyValueList(response)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  /**
   * 서버에서 전송되는 데이터 양을 줄이기 위해서 key 값과 value 값을 분리해서
   * 2개의 배열로 나눠서 전송할 수 있다.
   * 이 경우 분리된 key, value 값을 하나의 오브젝트로 결합하는 역할을 수행한다.
   * @param response
   * @returns {*}
   */
  static combineKeyValueList (response) {
    // 데이터가 존재하지 않으면 처리하지 않는다
    if (typeof response.data === 'undefined') {
      return response
    } else return response.data

    // eslint-disable-next-line no-unreachable
    const data = response.data

    // 반환된 데이터가 key, data 두 개의 키를 가진 object 일 경우에만 변환하도록 한다.
    if (Object.keys(data).length === 2 && data.hasOwnProperty('key') && data.hasOwnProperty('data')) {
      const oldKey = data.key
      const oldData = data.data
      const newData = []

      // 한 줄 한 줄 변경한다..
      // 이로 인해서 클라이언트 쪽의 연산량은 늘어났지만 서버와 통신량이 줄어든다
      for (const oldDataRow of oldData) {
        const newDataRow = {}
        const keySize = oldKey.length
        for (let i = 0; i < keySize; i++) {
          const key = oldKey[i]
          newDataRow[key] = oldDataRow[i]
        }
        newData.push(newDataRow)
      }

      // 변환된 데이터로 교체한다
      response.data = newData
    }

    return response
  }

  static verifyAccessToken () {
    try {
      const token = VueCookie.get('token')
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    } catch (err) {
      axios.defaults.headers.common['Authorization'] = ''
    }
  }

  static tooManyRequest (err) {
    if (err.response.status === 429) {
      if (!this.isErrorAlert) {
        this.isErrorAlert = true
        alert('짧은 시간동안 서버에 너무 많은 요청을 하였습니다. \n1분 뒤 다시 시도해주세요.')
        this.isErrorAlert = false
      }
    }
  }
}

export default HttpRequest
